import NavMenu from "components/layout/NavMenu/NavMenu";
import TopMenu from "components/layout/TopMenu/TopMenu";
import React from "react";
import featureFlags from "utils/featureFlags";

const Header: React.FC = () =>
  featureFlags.rebrand ? (
    <>
      {React.createElement("elexon-global-header")}
      {/* TODO: #303394 The widget nav bar is being displayed along side the original nav bar on dev
          to allow Xanda to test, this is temporary and should be removed once complete */}
      {featureFlags.displayDevBanner &&
        React.createElement("elexon-insights-header")}
      <NavMenu />
    </>
  ) : (
    <header>
      <TopMenu />
      <NavMenu />
    </header>
  );

export default Header;
